import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import "font-awesome/css/font-awesome.min.css";
import Analytics from "./features/analytics/Analytics";
import DatadogRum from "./features/datadog/DatadogRum";

ReactDOM.render(
  <React.StrictMode>
      <Analytics debug={process.env.REACT_APP_ENVIRONMENT === "local"}>
        <DatadogRum enabled={process.env.REACT_APP_DATADOG_RUM_ENABLED} />
        <App />
      </Analytics>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
